import styled, { keyframes } from 'styled-components';
import { math } from 'polished';
import theme, { combineValues } from '@cld/theme-helper';
import { iconMixin } from '@cld/icon';

const rotation = keyframes`
   from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
`;

export default styled.div.attrs((props) => ({
  size: props.size || 'md',
  variant: props.variant || 'primary',
  color: combineValues(theme`color.${'color'}`, theme`palette.${'variant'}`, (color, themeColor) => color || themeColor)(props),
}))`
  ${iconMixin};
  animation: ${rotation} 1s infinite linear;
  border-radius: 100%;

  &:before {
    content: '';
    display: block;
    position: absolute;
    height: 100%;
    width: 100%;
    border-top: ${combineValues(theme`components.icon.${'size'}`, (size) => math(`${size} / 8`))} solid ${(props) => props.color};
    border-left: ${combineValues(theme`components.icon.${'size'}`, (size) => math(`${size} / 8`))} solid ${(props) => props.color};
    border-bottom: ${combineValues(theme`components.icon.${'size'}`, (size) => math(`${size} / 8`))} solid ${(props) => props.color};
    border-right: ${combineValues(theme`components.icon.${'size'}`, (size) => math(`${size} / 8`))} solid transparent;
    border-radius: 100%;
  }
`;
